import Cookies from "js-cookie";
import querystring from "querystring";
import fetch from "isomorphic-unfetch";
import getConfig from "next/config";

const { publicRuntimeConfig } = getConfig();

let API_URL = publicRuntimeConfig?.API_URL || process.env.API_URL;

class RestAPIClient {
  public static getToken = () => {
    try {
      return `${Cookies.getJSON("x-access-token")}`;
    } catch (e) {
      return "";
    }
  };

  public static getEndpoint = async () => {
    const res = await fetch("/api/env");
    const json = await res.json();
    return json?.API_URL;
  };

  public static getEnv = async () => {
    const res = await fetch("/api/env");
    const json = await res.json();
    return json;
  };

  protected api_url = API_URL;

  protected path: string;

  protected auth: boolean;

  private static process401 = () => {};

  constructor(path: string, auth: boolean = true) {
    this.path = path;
    this.querystring = querystring;
    this.auth = auth;
  }

  protected querystring: typeof querystring;

  private async request(
    contextPath: string,
    method: string,
    payload?: any,
    host?: string
  ) {
    const token = RestAPIClient.getToken();
    if (this.auth && (!token || token === "undefined")) {
      RestAPIClient.process401();
      throw new Error("UNAUTHORIZED");
    }

    const _API_URL = API_URL || (await RestAPIClient.getEndpoint());

    API_URL = _API_URL;

    let url = `${_API_URL}/${this.path}${contextPath}`;
    if (host) {
      url = `${host}/${this.path}${contextPath}`;
    }

    if (method === "GET" && payload) {
      url = `${url}?${querystring.stringify(payload || {})}`;
    }

    const options: RequestInit = {
      method,
      headers: {
        authorization: `Bearer ${token}`,
        // "Content-Type": "application/json",
      },
      credentials: "include",
      redirect: "follow",
    };

    if (method === "POST" || method === "PUT" || method === "PATCH") {
      options["body"] =
        payload instanceof FormData ? payload : JSON.stringify(payload);
    }
    const res = await fetch(url, options);

    try {
      switch (true) {
        case res.status === 401: {
          RestAPIClient.process401();
          const json = await res?.json();
          if (!!json) {
            const error = {
              ...json,
              status: res.status,
            };
            throw error;
          } else {
            const error = {
              message: res.statusText,
              status: res.status,
            };
            throw error;
          }
        }
        case res.status === 400: {
          const json = await res?.json();
          throw json;
        }
        case res.status === 301 ||
          res.status === 302 ||
          res.type === "opaqueredirect": {
          // RestAPIClient.process30x();
          break;
        }
        case res.status > 201:
          const json = await res?.json();
          if (!!json) {
            const error = {
              ...json,
              status: res.status,
            };
            throw error;
          } else {
            const error = {
              message: res.statusText,
              status: res.status,
            };
            throw error;
          }

        case res.status === 200 || res.status === 201: {
          const json = await res.json();
          if (json.success !== true) {
            throw json;
          }
          return json;
        }
      }
    } catch (e) {
      throw e;
    }
  }

  protected get = (contextPath = "", params?: object) =>
    this.request(contextPath, "GET", params);

  protected post = (contextPath = "", body: object | FormData = {}) =>
    this.request(contextPath, "POST", body);

  protected put = (contextPath = "", body: object = {}) =>
    this.request(contextPath, "PUT", body);

  protected patch = (contextPath = "", body: object = {}) =>
    this.request(contextPath, "PATCH", body);

  protected delete = (contextPath = "") => this.request(contextPath, "DELETE");
}

export default RestAPIClient;
